import React from "react";
import { withTranslation } from "react-i18next";
import { Card, Input, Label, Table, Button } from "reactstrap";

const AuditLogCardSkeleton: React.FC = ({ t }: any) => {
	return (
		<>

			{/* Filters */}
			<div className="mb-1 bg-light px-3 py-3">
				<div className="d-flex justify-content-start align-items-center mb-2 gap-2">
					<h5 className="fw-semibold mb-0 placeholder-glow">
						<span className="placeholder col-4"></span>
					</h5>
					<Button color="danger" className="btn-label btn-sm disabled placeholder col-2">
						<i className="ri-refresh-line label-icon align-middle fs-16 me-2"></i>
						<span className="placeholder col-6"></span>
					</Button>
				</div>

				<div className="row d-flex justify-content-between">
					{[1, 2, 3].map((i) => (
						<div key={i} className="col-md-4 d-flex flex-column justify-content-between placeholder-glow">
							<Label className="form-label text-muted fw-medium small mb-1 d-flex align-items-center">
								<span className="placeholder col-6"></span>
							</Label>
							<div className="text-muted small mb-1">
								<span className="placeholder col-8"></span>
							</div>
							<div className="form-control placeholder col-12 py-2"></div>
						</div>
					))}
				</div>
			</div>


			{/* Activity Table */}
			<div className="mb-5 d-flex flex-column gap-1">
				<h5 className="fw-semibold">{t("footprints.activities")}</h5>
				<Table className="align-middle table-nowrap mb-0 table-bordered rounded">
					<thead className="table-light">
						<tr>
							<th style={{ width: "12%" }}>Timestamp</th>
							<th style={{ width: "15%" }}>Lead Name</th>
							<th style={{ width: "10%" }}>Type</th>
							<th style={{ width: "10%" }}>Action</th>
							<th style={{ width: "12%" }}>Time Spent</th>
							<th style={{ width: "25%" }}>Details</th>
							<th style={{ width: "8%" }}>Points</th>
							<th style={{ width: "8%" }}>Gap</th>
						</tr>
					</thead>
					<tbody>
						{[1, 2].map((hourBlock) => (
							<React.Fragment key={hourBlock}>
								{/* Block Header Row */}
								<tr className="bg-light fw-semibold text-dark">
									<td colSpan={8}>
										<div className="d-flex justify-content-between align-items-center placeholder-glow">
											<div className="placeholder col-3"></div>
											<div className="placeholder col-3"></div>
											<div className="placeholder col-1"></div>
										</div>
									</td>
								</tr>
								{/* 3 Placeholder Rows */}
								{[1, 2, 3].map((log) => (
									<tr key={log} className="placeholder-glow">
										{[...Array(8)].map((_, idx) => (
											<td key={idx}><span className="placeholder col-8"></span></td>
										))}
									</tr>
								))}
							</React.Fragment>
						))}
					</tbody>
				</Table>
			</div>
		</>
	);
};

export default withTranslation()(AuditLogCardSkeleton);
